// Shared game type color mapping for icon styles.
export const getGameTypeColors = (gameTypeId) => {
  const colorMap = {
    snake: {
      icon: '#10B981',
      bg: 'rgba(16, 185, 129, 0.14)',
      border: 'rgba(16, 185, 129, 0.35)'
    },
    runner: {
      icon: '#F59E0B',
      bg: 'rgba(245, 158, 11, 0.14)',
      border: 'rgba(245, 158, 11, 0.35)'
    },
    sidescroller: {
      icon: '#3B82F6',
      bg: 'rgba(59, 130, 246, 0.14)',
      border: 'rgba(59, 130, 246, 0.35)'
    },
    verticalclimber: {
      icon: '#8B5CF6',
      bg: 'rgba(139, 92, 246, 0.14)',
      border: 'rgba(139, 92, 246, 0.35)'
    },
    flappy: {
      icon: '#14B8A6',
      bg: 'rgba(20, 184, 166, 0.14)',
      border: 'rgba(20, 184, 166, 0.35)'
    },
    quizrush: {
      icon: '#0EA5E9',
      bg: 'rgba(14, 165, 233, 0.14)',
      border: 'rgba(14, 165, 233, 0.35)'
    },
    minigolf: {
      icon: '#22C55E',
      bg: 'rgba(34, 197, 94, 0.14)',
      border: 'rgba(34, 197, 94, 0.35)'
    },
    stacker: {
      icon: '#F97316',
      bg: 'rgba(249, 115, 22, 0.14)',
      border: 'rgba(249, 115, 22, 0.35)'
    },
    hint: {
      icon: '#F59E0B',
      bg: 'rgba(245, 158, 11, 0.14)',
      border: 'rgba(245, 158, 11, 0.35)'
    },
    quiz: {
      icon: '#3B82F6',
      bg: 'rgba(59, 130, 246, 0.14)',
      border: 'rgba(59, 130, 246, 0.35)'
    },
    'progressive-reveal': {
      icon: '#F59E0B',
      bg: 'rgba(245, 158, 11, 0.14)',
      border: 'rgba(245, 158, 11, 0.35)'
    }
  };

  const fallback = {
    icon: 'var(--admin-accent)',
    bg: 'rgba(99, 102, 241, 0.14)',
    border: 'rgba(99, 102, 241, 0.35)'
  };

  return colorMap[gameTypeId] || fallback;
};
